export enum ONBOARDING_LADDER_STEP_KIND {
  DERIVED = 'derived',
  ACKNOWLEDGED = 'acknowledged',
  COMING_SOON = 'coming_soon',
}
